import {isNullOrUndefined} from "../../../services/Validator";

export default function GlossaryLetterText({letter}) {
    // Used in GlossaryTermsByLetterList to display single letter
    // that contains terms

    // BUILD
    if (isNullOrUndefined(letter))
        return null
    return (
        <div>
            <span className="text-[16px] font-semibold text-primaryLight2">
                {letter}
            </span>
        </div>
    );
}